/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { createPortal } from "react-dom";
import { useAuditLog } from "../hook/use-audit-log";
import { ListFooter } from "@/components/shared/list-footer";
import { format } from "date-fns";

import { AuditLogViewer } from "./audit-log-viewer";
import { AuditCollapsible } from "./audit-collapsible";

export const DocumentAuditLogPopup = ({
  /* open, */ setOpen,
  doc_id,
  company_id,
  user_id,
  domain_id,
}: any) => {
  const { list, loading, onPageChange, onPerPageChange, paginationData } =
    useAuditLog({
      doc_id,
      company_id,
      user_id,
      setOpen,
      open,
      domain_id,
    });

  if (loading) {
    return null;
  }

  // const HEADER = ["cts", "old_data", "new_data"];
  return createPortal(
    <div className="fixed left-0 top-0 w-full h-full z-50 flex justify-center items-center bg-black/50">
      <div className="bg-white rounded-md w-[90%] h-[90%] overflow-hidden">
        <div className="flex justify-between px-5 items-center py-3 border">
          <h3>Audit Log</h3>
          <Button
            size={"icon"}
            variant={"outline"}
            className={"text-red-500"}
            onClick={() => setOpen(false)}
          >
            <X />
          </Button>
        </div>
        <div className="scrollbar h-[78%] overflow-auto px-5 my-2 border-b">
          <div className="">
            {list.length === 0 ? (
              <div>
                <div>
                  <div className="flex items-center justify-center h-[400px] text-slate-500 text-2xl">
                    Record not found
                  </div>
                </div>
              </div>
            ) : null}
            <div className="flex flex-col gap-5 py-5">
              {list?.map((item: any, rowIndex: number) => {
                return (
                  <div key={rowIndex} className="w-full">
                    <AuditCollapsible
                      preLabel="Created on:"
                      label={format(item["cts"], "MMM dd, yyyy, hh:mm a")}
                      modifiedBy={item["modified_by"]}
                    >
                      <div className="flex w-full">
                        <div className="w-1/2 pr-5">
                          <div className="mb-2 mt-2 text-primary">Old Data</div>
                          <AuditLogViewer documentData={item["old_data"]} />
                        </div>
                        <div className="w-1/2 pl-5">
                          <div className="mb-2 mt-2 text-primary">New Data</div>
                          <AuditLogViewer documentData={item["new_data"]} />
                        </div>
                      </div>
                    </AuditCollapsible>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <ListFooter
          onPageChange={onPageChange}
          onPerPageChange={onPerPageChange}
          page={paginationData.page}
          perPage={paginationData.perPage}
          totalItem={paginationData.totalItem}
          className="px-5 py-5"
          isEmpty={list.length === 0}
        />
      </div>
    </div>,
    document.body
  );
};
